const shadowSet = {
    elevation: 5,
    shadowOffset: {
        height: 0, width: 0
    },
    shadowOpacity: 0.3,
    shadowRadius: 3,
}

export { shadowSet }